module.exports = __webpack_public_path__ + "img/Dantam Bridal 04.8702ed83.jpg";